<template lang="pug">
.about(
  :style="{height: height}")
  b-header
  .container(
    ref="fullpage",
    v-fullpage="opts",
    @mousewheel="mousewheel"
    @wheel="mousewheel")
    .page(
      @mousewheel.stop="mousewheel_about",
      ref="about",
      :style="{height: height, overflowY: 'scroll', paddingBottom: '20px'}")
      .nav
        transition(name="left-in")
          .line(v-if="animateCtrl[0]")
        transition(name="right-in")
          .title(v-if="animateCtrl[0]") {{langs[lang].aboutTItle1}}
        transition(name="bottom-in-delay")
          ul(v-if="animateCtrl[0]")
            li(@click="turnToA(0)") {{langs[lang].aboutTItle1}}
      .page.page_about_1
        .imgs
          .img
          .item
            .mask
              transition(name="bottom-in")
                .title(v-if="animateCtrl[0]") {{langs[lang].aboutTItle1}}
              transition(name="left-in")
                .desc(v-if="animateCtrl[0]") {{langs[lang].aboutDetail1}}
</template>

<script>
import header from "./header";
import footer from "./footer";
import fanpage from "../mixin/fanpage.js";
const About = {
  mixins: [fanpage],
  props: [],
  data() {
    return {
      aboutList: [],
      detail: "",
      current: 0,
      langs: {
        en: {
          aboutTItle1: "About BAI",
          aboutDetail1:
            "Founded in January 2008, Bertelsmann Asia Investments has invested in more than 200 portfolio companies including 16 IPOs and 40+ unicorns. Bertelsmann Asia Investments focuses on sectors including Urbanization and Retail, Finance, China Based Global Company, Social/ Media/ Content and Tech & Infrastructure. As an evergreen fund, The firm accompanies portfolios’ growth with a long-term and strategic vision. Bertelsmann Asia Investments also has access to Bertelsmann’s vast resources and global channels to facilitate the expansion plans of startups.",
          aboutTItle2: "About Betafund",
          aboutDetail2: `In October 2014, BAI set up a dedicated fund, BetaFund, to promote business ideas at the very early “angel” stage, focusing on early-stage companies with excellent performance in mobility, social networking, intelligent hardware, games, education, enterprise services and contents.
BetaFund will provide capital support and professional services of every operational stage for startups seeking angel-stage investments, to create a closed-loop investment, while synergizing with Bertelsmann’s business units by facilitating close partnerships. Up till now, most of the companies under Betafund’s portfolio have been through next round of investment and have benefited from BAI’s continuous support.`,
          aboutTItle3: "About Bertelsmann",
          aboutDetail3:
            "Bertelsmann is a media, services and education company that operates in about 50 countries around the world. It includes the broadcaster RTL Group, the trade book publisher Penguin Random House, the magazine publisher Gruner + Jahr, the music company BMG, the service provider Arvato, the Bertelsmann Printing Group, the Bertelsmann Education Group and Bertelsmann Investments, an international network of funds. The company has 126,000 employees and generated revenues of €18.0 billion in the 2019 financial year. Bertelsmann stands for creativity and entrepreneurship. This combination promotes first-class media content and innovative service solutions that inspire customers around the world. Bertelsmann aspires to achieve climate neutrality by 2030.",
        },
        zh: {
          aboutTItle1: "关于贝塔斯曼亚洲投资基金",
          aboutDetail1:
            "贝塔斯曼亚洲投资基金成立于2008年1月，由国际传媒、教育、服务巨头贝塔斯曼集团全资控股，坚持走精品路线，依托贝塔斯曼集团在全球的资源网络，帮助创业者开拓布局，也用更为长期和战略的眼光陪伴企业成长。",
          aboutTItle2: "关于BAI梦想基金",
          aboutDetail2:
            "2014年10月，BAI正式成立了规模达数千万美元的专项天使基金，关注移动、社交、智能硬件、游戏、教育、企业服务和内容等优秀的早期公司。BetaFund将为天使阶段的创业者提供资金支持和各个运营阶段的专业服务，实现创业投资的闭环，并积极推动被投企业与贝塔斯曼业务单元的紧密合作，实现协同效应。目前，BetaFund中多数公司都实现了下一轮融资，并得到了BAI的持续支持。",
          aboutTItle3: "关于贝塔斯曼集团",
          aboutDetail3:
            "贝塔斯曼集团成立于1835年，是全球领先的传媒巨擘，业务遍及50多个国家。整个联营集团包括八大业务单元。2019 财年，贝塔斯曼集团营收达到 180亿欧元。贝塔斯曼是创造力与创业家精神的代名词，为全球客户带来顶尖的媒体服务与创新解决方案。",
        },
      },
    };
  },
  mounted() {
    this.animateCtrl[0] = 1;
    document.body.scrollTop = 0;
    this.current = +this.$route.query.page || 0;
    this.animateCtrl[this.current - 1] = 1;
    this.turnTo(this.current);
    window.$http
      .get(window.hostName + "wp-json/wp/v2/about?per_page=100")
      .then((res) => {
        let aboutList = res.data
          .map((item) => {
            return {
              title: item.title.rendered,
              content: item.content.rendered,
              main_title: item.main_title,
              award: item.award,
              institutions: item.institutions,
              categories: item.categories[0],
            };
          })
          .filter((item) => {
            if (this.lang === "zh") {
              return (
                /[\u4e00-\u9fa5]/.test(item.title) ||
                /[\u4e00-\u9fa5]/.test(item.content)
              );
            } else {
              return (
                !/[\u4e00-\u9fa5]/.test(item.title) &&
                !/[\u4e00-\u9fa5]/.test(item.content)
              );
            }
          })
          .slice(0, 6);
        this.aboutList = aboutList.filter((item) => {
          return item.categories !== 71;
        });
        this.detail = aboutList
          .filter((item) => {
            return item.categories === 71;
          })[0]
          .content.split("\n")
          .slice(0, -1);
      })
      .catch(function (err) {
        console.log("err:", err);
      });
  },
  components: {
    bFooter: footer,
    bHeader: header,
  },
  computed: {
    lang() {
      return localStorage.lang;
    },
    isMobi() {
      return window.isMobi;
    },
    totalPage() {
      return 0;
    },
  },
  methods: {
    beforeEnter: function (el) {
      window.Velocity.hook(el, "translateY", "-20px");
      window.Velocity.hook(el, "opacity", 0);
    },
    turnToA(page) {
      this.animateCtrl[page] = page;
      if (this.isMobi && page) {
        this.turnTo(page + 1);
        this.$moveTo(page + 1);
      } else {
        this.turnTo(page);
        this.$moveTo(page);
      }
    },
    enter: function (el, done) {
      var delay = el.dataset.index * 50;
      window.Velocity(
        el,
        {
          opacity: 1,
          translateY: 0,
        },
        {
          duration: 500,
          delay,
          complete: done,
        }
      );
    },
    beforeLeftEnter: function (el) {
      window.Velocity.hook(
        el,
        "translateX",
        el.dataset.index % 2 ? "100px" : "-100px"
      );
      window.Velocity.hook(el, "opacity", 0);
    },
    leftenter: function (el, done) {
      var delay = el.dataset.index * 50;
      window.Velocity(
        el,
        {
          opacity: 1,
          translateX: 0,
        },
        {
          duration: 500,
          delay,
          complete: done,
        }
      );
    },
    mousewheel_about(e) {
      let top = this.$refs.about.scrollTop;
      if (
        (top <= 0 && e.deltaY < 0) ||
        (top >= this.$refs.about.scrollHeight - this.$refs.about.clientHeight &&
          e.deltaY > 0)
      ) {
        this.mousewheel(e);
      }
    },
    linkto(url) {
      window.location.href = url;
    },
  },
};
export default About;
</script>

<style scoped lang="stylus">
@import '../common.styl'
@media (max-width: 720px) {
  .bar{
    overflow: hidden;
    width: 1200px;
    margin: 100px auto;
    background-color: #fff;
    padding: 50px 0;
    .items{
      position: relative;
      top: 100px;
    }
    .item{
      width: 90%;
      margin: 0 auto;
      padding: 50px 0;
      &+.item{
        border-top: 1px solid #002b69;
      }
      &:last-child{
        border-bottom: none;
      }
      .title{
        font-size: 28px;/*no*/
        margin: 20px 0 10px;
        color: #002b69;
        font-weight: bold;
        text-align: center;
      }
      .desc{
        text-align: center;
        color: #002b69;
        font-size: 12px;/*no*/
        margin-top: 10px;
        .logo{
          width: 100%;
        }
      }
    }
  }
  p{
    width: 1000px;
    font-size: 24px;/*no*/
    text-align: center;
    color: #002b69;
    margin: 5px auto;
  }
  .page{
    &.page_about_1{
      height: 2000px;
      .imgs{
        background: url(../assets/about/1.jpg) top left / 200%;
      }
    }
    &.page_about_2 .imgs{
      position: absolute;
      top: 350px;
      background: url(../assets/about/2.jpg) top left / 200%;
    }
    &.page_about_3 .imgs{
      position: absolute;
      top: 350px;
      background: url(../assets/about/3.jpg) top left / 200%;
    }
    .imgs{
      width: 100%;
      height: 2000px;
      .item{
        float: left;
        width: 100%;
        height: 50%;
        .mask{
          position: relative;
          background: rgba(255,255,255,.8);
          padding: 100px;
          width: 100%;
          height: 95%;
          &:before{
            content: "";
            display: block;
            width: 100%;
            position: absolute;
            height: 20px;
            top: -20px;
            left: 0;
            background: #002b69;
          }
          .title{
            font-size: 18px;/*no*/
            margin-bottom: 50px;
            font-weight: bold;
            color: #002b69;
          }
          .desc{
            font-size: 14px;/*no*/
            line-height: 1.5;
            color: #002b69;
            .logo{
              margin: 0% 25%;
              width: 50%;
            }
          }
        }
        .mask_big{
          height: 120%;
        }
      }
    }
  }
}
@media (min-width: 720px) {
  .bar{
    overflow: hidden;
    width: 1720px;
    margin: 0 100px 50px;
    background-color: #fff;
    height: 220px;
    position: absolute;
    top: 475px;
    padding: 20px 0;
    .top-item{
      float: left;
      width: 20%;
      height: 100%;
      border-right: 1px solid #002b66;/*no*/
      &:last-child{
        border-right: none;
      }
      .title{
        font-size: 40px;/*no*/
        margin: 20px 0 10px;
        color: #000;
        font-weight: bold;
        text-align: center;
      }
      .desc{
        text-align: center;
        color: #000;
        font-size: 14px;/*no*/
        margin-top: 10px;
        width: 94%;
        margin: 0 auto;
        .logo{
          width: 100%;
        }
      }
    }
  }
  p{
    font-size: 18px;/*no*/
    text-align: center;
    color: #002b69;
    margin: 5px 0;
  }
  .page{
    &.page_about_1 {
      height: 730px;
      .imgs{
        transform: translate(0, 0);
        top: 0;
        background: url(../assets/about/1.jpg) center / cover;
      }
    }
    &.page_about_2 .img{
      background: url(../assets/about/2.jpg) center / cover;
    }
    &.page_about_3 .img{
      background: url(../assets/about/3.jpg) center / cover;
      height: 538px;
    }
    .imgs{
      width: 100%;
      height: 475px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      .img{
        -webkit-filter: grayscale(100%);
        filter: grayscale(100%);
        -webkit-filter: #808080;
        filter: #808080;
        transition: all 1s;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: -1;
        &:hover{
          -webkit-filter: grayscale(0%);
          filter: grayscale(0%);
          -webkit-filter: transparent;
          filter: transparent
        }
      }
      .item{
        float: left;
        width: 50%;
        height: 100%;
        &.hover{
          &:hover{
            background: rgba(255,255,255,.5);
            padding: 50px 100px;
            height: 100%;
          }
        }
        .mask{
          position: relative;
          background: rgba(255,255,255,.8);
          padding: 50px 100px;
          width: 100%;
          height: 100%;
          &:before{
            content: "";
            display: block;
            width: 100%;
            position: absolute;
            height: 20px;
            top: -20px;
            left: 0;
            background: #002b69;
          }
          .title{
            font-size: 28px;
            margin-bottom: 50px;
            font-weight: bold;
            color: #002b69;
          }
          .desc{
            font-size: 18px;
            line-height: 1.5;
            color: #002b69;
            .logo{
              margin: 0% 15%;
              width: 60%;
            }
          }
        }
      }
    }
  }
}
.pointer{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// about.vue?efc069ac